const isLocalhost = () =>
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

const isLighthouse = () =>
  typeof navigator !== 'undefined' &&
  navigator.userAgent?.toLowerCase().includes('lighthouse');

const isDisabledByEnv = () => import.meta.env.VITE_DISABLE_TRACKING === 'true';

export function shouldEnableTracking() {
  return (
    import.meta.env.PROD &&
    !isDisabledByEnv() &&
    !isLocalhost() &&
    !isLighthouse()
  );
}

export function initGoogleAnalytics() {
  if (typeof window === 'undefined') return false;

  if (!shouldEnableTracking()) {
    window.__TRACKING_DISABLED__ = true;
    return false;
  }

  const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (!gaId || gaId === 'GA_MEASUREMENT_ID') {
    return false;
  }

  if (window.gtag) return true;

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  window.gtag('js', new Date());
  window.gtag('config', gaId);

  return true;
}
